<template>
  <div class="p-4 rounded-xl border border-[var(--color-border)]" style="background: var(--color-surface)">
    <div class="text-sm font-semibold">{{ title ?? $t('common.save') }}</div>
    <BaseFormField :label="$t('common.name')" required>
      <BaseInput
        :model-value="modelValue.name"
        placeholder="Områdenavn"
        @update:model-value="update('name', $event)"
      />
    </BaseFormField>
    <BaseFormField :label="$t('common.location')">
      <BaseSelect
        :model-value="modelValue.location"
        @update:model-value="updateLocation($event)"
      >
        <option value="">{{ $t('common.noLocation') }}</option>
        <option v-for="loc in locations" :key="loc.id" :value="loc.id">{{ loc.name }}</option>
      </BaseSelect>
    </BaseFormField>
    <BaseFormField :label="$t('common.warehouse')">
      <BaseSelect
        :model-value="modelValue.warehouse"
        @update:model-value="update('warehouse', $event)"
      >
        <option value="" disabled>{{ $t('common.selectWarehouse') }}</option>
        <option v-for="w in filteredWarehouses" :key="w.id" :value="w.id">{{ w.name }}</option>
      </BaseSelect>
    </BaseFormField>
    <BaseFormActions
      :confirm-label="title || $t('common.save')"
      :loading="saving"
      :disabled="!modelValue.name || !modelValue.warehouse"
      @cancel="$emit('cancel')"
      @confirm="$emit('save')"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BaseFormField from '@/components/base/BaseFormField.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseSelect from '@/components/base/BaseSelect.vue'
import BaseFormActions from '@/components/base/BaseFormActions.vue'

const props = defineProps({
  modelValue: { type: Object, required: true },
  locations: { type: Array, default: () => [] },
  warehouses: { type: Array, default: () => [] },
  saving: { type: Boolean, default: false },
  title: { type: String, default: null },
})

const emit = defineEmits(['update:modelValue', 'save', 'cancel'])

const filteredWarehouses = computed(() =>
  props.modelValue.location
    ? props.warehouses.filter(w =>
        w.location === Number(props.modelValue.location) ||
        w.location?.id === Number(props.modelValue.location)
      )
    : props.warehouses
)

function update(field, value) {
  emit('update:modelValue', { ...props.modelValue, [field]: value })
}

function updateLocation(newLoc) {
  const currentWarehouse = props.modelValue.warehouse
  let warehouse = currentWarehouse
  if (newLoc && currentWarehouse) {
    const valid = props.warehouses.some(w =>
      w.id === Number(currentWarehouse) &&
      (w.location === Number(newLoc) || w.location?.id === Number(newLoc))
    )
    if (!valid) warehouse = ''
  }
  emit('update:modelValue', { ...props.modelValue, location: newLoc, warehouse })
}
</script>
